import axios from 'axios';

const developmentURL = 'https://www.makana.cl'; // 'http://192.168.100.104:8000';
const productionURL = 'https://www.makana.cl';

export const axiosBaseInstance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? productionURL : developmentURL,
});
